import React from 'react';
import { HelpCircle } from 'lucide-react';

export interface ServiceHelpButtonProps {
  label: string;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  className?: string;
}

/**
 * Yellow "?" help affordance — 44px touch target, does not propagate card clicks.
 */
export function ServiceHelpButton({ label, onClick, className = '' }: ServiceHelpButtonProps) {
  return (
    <button
      type="button"
      aria-label={`${label} — how it works`}
      title="How it works"
      className={`rounded-lg transition-colors hover:bg-yellow-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#EAB308] ${className}`}
      onClick={(event) => {
        event.stopPropagation();
        onClick(event);
      }}
      style={{
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '44px',
        height: '44px',
        color: '#EAB308',
        flexShrink: 0,
      }}
    >
      <HelpCircle className="w-5 h-5" strokeWidth={2.25} />
    </button>
  );
}
